const { ethers, ContractFactory, BigNumber } = require("ethers");
import Constants from "../../constants";
let provider = null;
let signer = null;

export default {
    async init () {
        if (ethers && ethers.providers && ethers.providers.Web3Provider && window && window.ethereum && signer == null) {
            provider = new ethers.providers.Web3Provider(window.ethereum, 1714);
            signer = provider.getSigner();
            await provider.send("eth_requestAccounts", []);
            const tokenAdded = localStorage.getItem('tokenAdded');
            if (tokenAdded == null || tokenAdded  !== 'true') {
                this.addBytos().then();
                localStorage.setItem('tokenAdded', 'true');
            }
        }
    },

    async addBytos () {
        const symbol = await this.call(Constants.contractByto, 'symbol', []);
        const decimals = await this.call(Constants.contractByto, 'decimals', []);
        await window.ethereum.request({
            method: 'wallet_watchAsset',
            params: {
                type: 'ERC20',
                options: {
                    address: Constants.contractByto.address,
                    symbol: symbol,
                    decimals: decimals,
                    image: 'https://upload.wikimedia.org/wikipedia/commons/0/0c/L%C3%ADnea_B_%28Logo_Metro_de_Medell%C3%ADn%29.svg', // A string url of the token logo
                },
            },
        });
    },
    async getMyAddress () {
        await this.init();
        return signer.getAddress();
    },
    getBN () {
        return BigNumber;
    },
    parseEther (value) {
        return ethers.utils.parseEther(value.toString());
    },
    decodeEther (value) {
        return parseFloat(value) / (10 ** 18);
    },
    getBalanceOf (address) {
        return provider.getBalance(address);
    },
    isAddress (address) {
        return ethers.utils.isAddress(address);
    },
    async deploy (contractData, args) {
        await this.init();
        const factory = new ContractFactory(contractData.abi, contractData.bytecode, signer);
        const tx = await factory.deploy(...args);
        return await tx.deployTransaction.wait();
    },
    async call (contractInfo, functionContract, args) {
        await this.init();
        const contract = new ethers.Contract(contractInfo.address, contractInfo.abi, provider);
        return contract[functionContract].apply(null, args);
    },
    async transaction (contractData, functionName, args, whaitToMine = true, value = 0) {
        await this.init();
        if (value > 0) {
            const overrides = {
                value: ethers.utils.parseEther(value.toString())
            };
            args.push(overrides);
        }
        const contract = new ethers.Contract(contractData.address, contractData.abi, signer);
        const tx = await contract[functionName].apply(null, args);
        if (whaitToMine) {
            return await tx.wait();
        } else {
            return tx;
        }
    },
    async sendETH (quantity, to) {
        return await signer.sendTransaction({to: to, value: ethers.utils.parseEther(quantity.toString())});
    },
};
